import { render, staticRenderFns } from "./AddActivityModal.vue?vue&type=template&id=b8a22796&scoped=true&"
import script from "./AddActivityModal.vue?vue&type=script&lang=js&"
export * from "./AddActivityModal.vue?vue&type=script&lang=js&"
import style0 from "./AddActivityModal.vue?vue&type=style&index=0&id=b8a22796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a22796",
  null
  
)

export default component.exports